<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool">
      <template slot="btn">
        <Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun">新增</Button>
        <Button @click="daoru" type="success" class="chaxun">导入</Button>
        <Button @click="exportAll" type="success" class="chaxun"
          >导出</Button
        ></template
      >
    </selectTool>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(240)"
    >
      <template slot-scope="{ row, index }" slot="proofList">
        <viewer v-if="row.proofList.length > 0">
          <img
            v-for="(x, index) in row.proofList"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增记录' : '编辑记录'"
      width="700"
      ref="formModel"
    >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <daoru ref="daoru" @finesh="getList"></daoru>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0
        },
        {
          title: "单位名称",
          key: "groupName",
          sort: 2
        },
        {
          title: "创建者账号",
          key: "createAccount",
          sort: 200
        },
        {
          title: "创建时间",
          key: "createTime",
          sort: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          }
        },
        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right"
        }
      ],
      tableData: [],
      item: {
        carId: 0,
        carNo: "",
        careCost: 0,
        careDate: Date.now(),
        cardNo: "",
        mileage: 0,
        proofList: [],
        careStation: "",
        careVolume: 0,
        remainVolume: 0,
        remark: "",
        type: "",
        unitPrice: 0
      },

      total: 0,
      forms: [
        {
          title: "车牌号",
          key: "carId",
          key1: "carNo",
          type: "selectCar",
          required: true
        },
        {
          title: "保养项目",
          key: "item",
          type: "Input",
          required: true
        },
        {
          title: "保养费用",
          key: "careCost",
          type: "InputNumber"
        },
        {
          title: "保养里程",
          key: "mileage",
          type: "InputNumber"
        },
        {
          title: "保养店名",
          key: "careShop",
          type: "Input"
        },
        {
          title: "保养日期",
          key: "careDate",
          key2: "careDate2",
          type: "lyyymmdd",
          required: true
        },
        {
          title: "图片",
          key: "proofList",
          slot: "proofList",
          type: "lyPhoto"
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          type1: "textarea",
          span: 24
        }
      ],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        startTime: 0,
        endTime: 0,
        carIdList: [],
        status: 3 //statue：1-审核，2-撤销。3-通过，
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "2,0,4"
        },
        {
          title: "选择车辆",
          carIdList: "carIdList",
          type: "selectAlotCar",
          times: "2,0,4"
        }
      ],
      imp: {
        temUrl: this.axios.ipPort + "/cloud-common-server-cost/care/tmpl",
        url: this.axios.ipPort + "/cloud-common-server-cost/care/imp"
      }
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.cost + "/care/list",
        data: this.searchItem
      }).then(res => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].careDate2 = this.utils.time(data[i].careDate, "yymmdd");
        }
        console.log(data);
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.cost + "/care/add",
          data: this.item
        }).then(res => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.cost + "/care/update",
          data: this.item
        }).then(res => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.cost + "/care/del",
            data: { idList: [row.id] }
          }).then(res => {
            if (res) {
              this.getList();
            }
          });
        }
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    exportAll() {
      var params = [
        {
          name: "endTime",
          value: this.searchItem.endTime
        },
        {
          name: "startTime",
          value: this.searchItem.startTime
        },
        {
          name: "carIdList",
          value: this.searchItem.carIdList
        }
      ];
      this.utils.exportData(this.axios.cost + "/care/export", params);
    },
    daoru() {
      this.$refs.daoru.reach(this.imp);
    }
  },
  mounted() {
    var config = {
      min: 150,
      max: 300
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// ../common/src/components/pay/carcare.vue